<template>
  <IconPicker
    :model-value="inputValue"
    @select="handleChange"
  />
</template>

<script setup lang="ts">
import useFormField, { defaultProps } from './useFormField'
import IconPicker from '~/components/ui/IconPicker.vue'

const props = defineProps(defaultProps)

const { inputValue, handleChange } = useFormField(props)
</script>
